import React, { useState } from "react";
import { Container, Form, Button, Row, Col, Modal } from "react-bootstrap";
import heroBg from "../assets/images/HeroBanner.png";
import { useNavigate } from "react-router-dom";
import "../styles/TermsOfService.css";

const TermsOfService = () => {
  const navigate = useNavigate();

  return (
    <>
      {/* Fixed Hero Section */}
      <section
        className="hero-fixed"
        style={{ backgroundImage: `url(${heroBg})` }}>

        <div className="hero-scroll-content">
          <div className="hero-content-home poppins-regular">
            <h1 className="hero-heading">All India Occupational Therapists' Association</h1>
          </div>
        </div>
      </section>

      {/* Scrollable Content Container */}
      <div className="scrollable-content-home">
        <div className="content-container terms-service-content-container">
          <section className="terms-service-section">
            <Container className="container-terms-service">
              <h2 className="text-center terms-service-heading mb-4">
                Terms Of Service
              </h2>

              {/* Introduction */}
              <Row className="mb-4">
                <Col>
                  <h3 className="terms-service-subheading">Introduction</h3>
                  <p className="terms-service-text">
                    Welcome to the All India Occupational Therapists' Association (AIOTA) website and services. These Terms of Service govern your use of our website, membership services, and all related features. By accessing or using our services, you agree to be bound by these terms and conditions.
                  </p>
                </Col>
              </Row>

              {/* Membership Terms */}
              <Row className="mb-4">
                <Col>
                  <h3 className="terms-service-subheading">Membership Terms</h3>
                  <div className="terms-service-text">
                    By applying for AIOTA membership, you agree to:
                    <ul className="terms-service-list">
                      <li>Provide accurate and complete information during registration.</li>
                      <li>Maintain current professional credentials and certifications.</li>
                      <li>Adhere to the professional code of conduct for occupational therapists.</li>
                      <li>Pay membership fees as required and maintain your membership status.</li>
                    </ul>
                  </div>
                </Col>
              </Row>

              {/* Website Usage */}
              <Row className="mb-4">
                <Col>
                  <h3 className="terms-service-subheading">Website Usage</h3>
                  <div className="terms-service-text">
                    You may use our website for lawful purposes only. You agree not to:
                    <ul className="terms-service-list">
                      <li>Use the site for any unauthorized commercial purposes.</li>
                      <li>Upload or share content that is harmful, offensive, or violates applicable laws.</li>
                      <li>Attempt to gain unauthorized access to any part of the website or other users' accounts.</li>
                      <li>Interfere with the proper functioning of the website or its security features.</li>
                    </ul>
                  </div>
                </Col>
              </Row>

              {/* Educational Services */}
              <Row className="mb-4">
                <Col>
                  <h3 className="terms-service-subheading">Educational Services and Courses</h3>
                  <p className="terms-service-text">
                    AIOTA offers various educational courses and continuing education programs. Registration fees are non-refundable unless explicitly stated otherwise. Course materials and content are protected by intellectual property rights and may not be redistributed without permission.
                  </p>
                </Col>
              </Row>

              {/* Liability and Disclaimers */}
              <Row className="mb-4">
                <Col>
                  <h3 className="terms-service-subheading">Liability and Disclaimers</h3>
                  <p className="terms-service-text">
                    AIOTA provides information and services "as is" without warranties of any kind. We are not liable for any damages arising from your use of our website or services. Professional advice and guidance provided through our platform should not replace individual professional judgment or consultation with qualified professionals.
                  </p>
                </Col>
              </Row>

              {/* Termination */}
              <Row className="mb-4">
                <Col>
                  <h3 className="terms-service-subheading">Termination</h3>
                  <p className="terms-service-text">
                    AIOTA reserves the right to terminate or suspend your access to our services at any time for violation of these terms or for any other reason deemed necessary. Upon termination, your right to use our services will cease immediately.
                  </p>
                </Col>
              </Row>

              {/* Contact Information */}
              <Row className="mb-4">
                <Col>
                  <h3 className="terms-service-subheading">Contact Us</h3>
                  <div className="terms-service-text">
                    If you have any questions about these Terms of Service, please contact us at:
                    <ul className="terms-service-list">
                      <li>Email: legal@aiota.org</li>
                      <li>Phone: +91-22-1234-5678</li>
                      <li>Address: AIOTA Headquarters, Mumbai, India</li>
                    </ul>
                  </div>
                </Col>
              </Row>

              {/* Terms Updates */}
              <Row className="mb-5">
                <Col>
                  <h3 className="terms-service-subheading">Changes to Terms</h3>
                  <p className="terms-service-text">
                    We reserve the right to modify these Terms of Service at any time. Changes will be effective immediately upon posting on this page. Your continued use of our services after any changes constitutes acceptance of the new terms.
                  </p>
                </Col>
              </Row>
            </Container>
          </section>
        </div>
      </div>
    </>
  );
};

export default TermsOfService;